<nts-toast-message></nts-toast-message>
<nts-loader [isVisible]="isLoading" [animation]="true" [skipHeader]="false"></nts-loader>
<router-outlet (activate)="isLoading = false"></router-outlet>
